/* TargetFilesComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./TargetFilesRenderer");
const disabledStatus = ["RUNNING", "COMPLETE", "CANCELED", "ERROR", "VALIDATING", "SCHEDULED"];

class TargetFilesComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._context = context;
        this._logger = context.logger;
        this._osPlanDetailsViewModel = context.osPlanDetailsViewModel;
        this._switchToEditImage = context.switchToEditImage.bind(this);
        this._gameEditor = context.gameEditor;
        this._plan = this._gameEditor.getPlan();

        if (_.includes(disabledStatus, this._gameEditor._plan.status)) {
            //should this be clickable?
            this._isCompleted = true;
        } else {
            this._isCompleted = false;
        }

        this._value = value;
        this._gameEditor = context.gameEditor;
        this._id = _.get(value, "id", null);
        this._isGrouped = _.get(value, "groupBy", null);
        this._plan = this._gameEditor.getPlan();
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._value = undefined;
            this._plan = undefined;
            this._id = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setTargetFiles(newVal);
        }
    }

    getValue() {
        return this.getTargetFiles();
    }

    setTargetFiles(newVal) {
        this._plan = newVal;
        this.emit("TargetFiles", newVal);
        return this;
    }

    getTargetFiles() {
        return this._plan;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = TargetFilesComponent;
